


















































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class LikeDislike extends Vue {
  @Prop({ default: null }) public value: boolean;
  @Prop({ default: false }) public doNotAnswer: boolean;
  @Prop({ default: false }) public enableDoNotAnswer: boolean;
  @Prop({ default: '' }) public accessibleContext!: string;

  public accessibleActionLabel(label: string): string {
    return this.accessibleContext ? `${this.accessibleContext}: ${label}` : label;
  }
}
